const GET_CURRENT_ANNOUNCEMENT = 'dofe-bo/ANNOUNCEMENT/GET_CURRENT_ANNOUNCEMENT'
const GET_CURRENT_ANNOUNCEMENT_SUCCESS = 'dofe-bo/ANNOUNCEMENT/GET_CURRENT_ANNOUNCEMENT_SUCCESS'
const GET_CURRENT_ANNOUNCEMENT_FAIL = 'dofe-bo/ANNOUNCEMENT/GET_CURRENT_ANNOUNCEMENT_FAIL'

const initialState = {
  loading: false,
  loaded: false,
  announcement: null
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CURRENT_ANNOUNCEMENT:
      return {
        ...state,
        loading: true
      }
    case GET_CURRENT_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        announcement: action.result
      }
    case GET_CURRENT_ANNOUNCEMENT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}


export function getCurrentAnnouncement(name = 'planned_maintenance') {
  return {
    types: [GET_CURRENT_ANNOUNCEMENT, GET_CURRENT_ANNOUNCEMENT_SUCCESS, GET_CURRENT_ANNOUNCEMENT_FAIL],
    promise: client =>
      client.get(`apiv2/system/announcement/content/get?name=${name}`)
  }
}
